import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments';

const isLocal =
  window.location.href.startsWith('http://localhost:') ||
  window.location.href.startsWith('https://localhost:');
const environmentName = isLocal
  ? 'local'
  : window.location.href.startsWith('https://fociva.com')
  ? 'production'
  : 'development';

if (!isLocal)
  Sentry.init({
    environment: environmentName,
    release: 'fociva-angular@' + environment.version,
    dsn: environment.sentry,
    autoSessionTracking: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      // capture console.error
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.1,

    tracePropagationTargets: [
      'localhost',
      /^https:\/\/app.devsandpit\.com\/api/,
      /^https:\/\/app.fociva\.com\/api/,
    ],

    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    ignoreErrors: [
      // To prevent errors being sent when localhost:4200 goes down
      'net::ERR_CONNECTION_REFUSED',
    ],
  });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
